import { Injectable } from '@angular/core';
import { first, map, Observable, tap } from 'rxjs';
import { AuditCategory, LeadAudit } from 'src/app/core/models/lead/lead-audit.model';
import { LeadRawValue } from 'src/app/core/models/lead/lead-raw-value.model';
import { Lead } from 'src/app/core/models/lead/lead.model';
import { ConfigurationProxyService } from 'src/app/infrastructure/lobby-proxy/lobby-proxy-configuration/configuration-proxy.service';
import { LeadProxyService } from 'src/app/infrastructure/lobby-proxy/lobby-proxy-lead/lead-proxy.service';
import { leadAuditDtoToLeadAudit } from 'src/app/shared/mappings/lead-model-dto/lead-audit-dto.mapping';
import { mapLeadDtoToLead } from 'src/app/shared/mappings/lead-model-dto/lead-dto.mapping';
import { jsonToLeadRawValue } from 'src/app/shared/mappings/lead-model-dto/lead-raw-value-json.mapping';
import { throwIfLobbyErrorCode } from 'src/app/shared/utils/pipes/throwIfLobbyErrorCode.pipe';

@Injectable({
  providedIn: 'root'
})
export class LeadInfoService {

  constructor(private readonly leadProxyService: LeadProxyService,
    private readonly configurationProxyService: ConfigurationProxyService) { }

  getLeadInfo$(leadId: number): Observable<Lead> {
    return this.leadProxyService.getLeadById$(leadId).pipe(
      throwIfLobbyErrorCode,
      map(dto => dto.data),
      mapLeadDtoToLead,
      first()
    )
  }

  getReceivedLeadInfo$(leadId: number): Observable<LeadRawValue[]> {
    return this.leadProxyService.getLeadAudits$(leadId, 0, 1, ['Injection'], 'All', 'Head').pipe(
      first(),
      map(result => jsonToLeadRawValue(result.data.find(e => AuditCategory[e.category as keyof typeof AuditCategory] == AuditCategory.Injection)?.data ?? JSON.parse('{}'))!)
    )
  }

  getLeadAudit$(leadId: number): Observable<LeadAudit[]> {
    return this.leadProxyService.getLeadAudits$(leadId, 0, 100, undefined, 'All', 'Summary', 'Created-')
      .pipe(
        first(),
        map(result =>
          result.data.map(dto => leadAuditDtoToLeadAudit(dto)!)
        )
      )
  }

  getAuditCategories$(): Observable<string[]> {
    return this.configurationProxyService.getLeadAuditCategories$()
      .pipe(
        first(),
        map(dto => dto.data.map(c => c.name))
      )
  }
}
